import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import utils from '@/utils/base.js'
import Vuex from "vuex";

Vue.use(Router)

// 关于路由
// 好像一开始就配置的不合理。
// children 要配合 router-view 来使用这样共用一套公共组件。
// 现在先分开写，等整理完功能再重新配置路由。
// 在这里先写一下构思,以免一会忘记了。
// 看了看语法就开始写了，一直没有整体上的把握。
// Vue 除去配置文件，一开始是从 App.vue 开始的，
// 教程上只在里面写了 <router-view></router-view> 然后开始写各种components 配顶层路由
// 也没多想， Vue 从 App.vue 进来，加载路由 <router-view></router-view>
// 这个router-view 显示的是顶层路由所配置的组件，
// 如果这个组件里也有router-view那应该展示的是children
// children 应该还能再嵌套...

const dynamicRouters = []
const files = require.context('@/apps/', true, /_router\.js$/)

files.keys().forEach(file => {
    dynamicRouters.push(...files(file).default.routes)
    // debugger
})

const __import__ = file => () => import(`@/pages/${file}.vue`)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: __import__('home'),
            meta: {
                title: '首页 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/jiekou_test',
            name: 'jiekou_test',
            component: __import__('api_test/api_test'),
            meta: {
                login: true,
                title: 'api测试 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: __import__('main/main_view'),
            meta: {
                login:true,
                title: '工作台 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/main/:view_id',
            name: 'main',
            component: __import__('main/main_view'),
            meta: {
                title: '管理 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/courses',
            name: 'courses',
            component: __import__('courses/course_home'),
            meta: {
                title: '课程学习 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/courses/reports',
            name: 'reports',
            component: __import__('courses/reports/reports'),
            meta: {
                title: '笔记 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/courses/reports/:id',
            name: 'report',
            component: __import__('courses/reports/report'),
            meta: {
                title: '笔记 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/courses/:id',
            name: 'course',
            component: __import__('courses/course'),
            meta: {
                title: '课程 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/path',
            name: 'path',
            component: __import__('path/path_home'),
            meta: {
                title: '专业路径 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/path/:id',
            name: 'coursePath',
            component: __import__('path/course_path'),
            meta: {
                title: '专业路径 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/stars',
            name: 'stars',
            component: __import__('stars/stars_home'),
            meta: {
                title: '成长明星 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/explore',
            name: 'explore',
            component: __import__('explore/explore_home'),
            meta: {
                title: '探索发现 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/questions',
            name: 'questions',
            component: __import__('questions/questions_home'),
            meta: {
                title: '在线问答 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/questions/publish',
            name: 'publish',
            component: __import__('questions/publish'),
            meta: {
                title: '提问 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/questions/:id',
            name: 'question',
            component: __import__('questions/question'),
            meta: {
                title: '问答 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/posts',
            name: 'posts',
            component: __import__('posts/post_home'),
            meta: {
                title: '文集 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/post/publish',
            name: 'post_publish',
            component: __import__('posts/publish'),
            meta: {
                title: '发文 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/post/edit/:id',
            name: 'post_edit',
            component: __import__('posts/edit'),
            meta: {
                title: '编辑 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/post/:id',
            name: 'post',
            component: __import__('posts/post'),
            meta: {
                title: '文集 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/group_buy/:id',
            name: 'group_buy',
            component: __import__('group_buy/group_buy'),
            meta: {
                title: '团购详情'
            }
        },
        {
            path: '/plus/:id',
            name: 'plusid',
            component: __import__('plus/plus'),
            meta: {
                title: '成长套餐'
            }
        },
        {
            path: '/plus',
            name: 'plus',
            component: __import__('plus/plus_home'),
            meta: {
                title: '佑＋成长套餐'
            }
        },
        {
            path: '/vip',
            name: 'vip',
            component: __import__('vip/vip'),
            meta: {
                title: '会员中心'
            }
        },
         {
            path: '/pay-success',
            name: 'pay-success',
            component: __import__('pay/success'),
            meta: {
                title: '支付成功'
            }
        },
         {
            path: '/pay-fail',
            name: 'pay-fail',
            component: __import__('pay/fail'),
            meta: {
                title: '支付失败'
            }
        },
        {
            path: '/courses/:id/learning/',
            name: 'learning',
            component: __import__('learning/learning'),
            meta: {
                title: '在线学习 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/c/:id/playback/',
            name: 'playback',
            component: __import__('learning/learning'),
            meta: {
                title: '视频回看 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/user/profile',
            name: 'userProfile',
            component: __import__('user/profile/profile'),
            meta: {
                title: '个人设置 - 成长之路 - 佑佐全域职业规划系统',
                login: true
            }
        },
        {
            path: '/user/:id',
            name: 'user',
            component: __import__('user/user'),
            meta: {
                title: '用户 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/password_find',
            name: 'password_find',
            component: __import__('password_find/password_find'),
            meta: {
                title: '密码找回 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/search',
            name: 'search',
            component: __import__('search/search'),
            meta: {
                title: '搜索 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/library',
            name: 'library',
            component: __import__('library/library'),
            meta: {
                title: '资源 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/library/:id',
            name: 'library_with_id',
            component: __import__('library/library_doc'),
            meta: {
                title: '资源 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: __import__('client_area/login'),
            meta: {
                title: '登录 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/live',
            name: 'live',
            component: __import__('live/live'),
            meta: {
                title: '直播课 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/contests',
            name: 'contests',
            component: __import__('contests/contests'),
            meta: {
                title: '挑战赛 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/skill/self_score/:id',
            name: 'skill_with_id',
            component: __import__('skill/skill_self_score'),
            meta: {
                title: '专业技能 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/skill/self_score',
            name: 'skill',
            component: __import__('skill/skill_self_score'),
            meta: {
                title: '专业技能自评 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/skill/skill_target',
            name: 'skill_target',
            component: __import__('skill/skill_target'),
            meta: {
                title: '技能提升目标 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/skill/skill_target/:id',
            name: 'skill_target_with_id',
            component: __import__('skill/skill_target'),
            meta: {
                title: '技能提升目标 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/skill/skill_submit',
            name: 'skill_submit',
            component: __import__('skill/skill_submit'),
            meta: {
                title: '评估资料 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/skill/self_score_state',
            name: 'skill_state',
            component: __import__('skill/skill_self_score_state'),
            meta: {
                title: '专业技能情况 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/eval/eval_position_state',
            name: 'eval_state',
            component: __import__('eval/eval_position_state'),
            meta: {
                title: '职业评估情况 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/eval_position',
            name: 'eval_position',
            component: __import__('eval/eval_position'),
            meta: {
                title: '职业发展评估 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/position_target',
            name: 'position_target',
            component: __import__('eval/position_target'),
            meta: {
                title: '职业目标规划 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/position_target_state',
            name: 'position_target_state',
            component: __import__('eval/position_target_state'),
            meta: {
                title: '职业目标规划 - 成长之路 - 佑佐全域职业成长系统'
            }
        },
        {
            path: '/eval',
            name: 'eval',
            component: __import__('eval/eval_home'),
            meta: {
                title: '专业评估 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/questionnaire/:number',
            name: 'questionnaire',
            component: __import__('questionnaire/questionnaire_home'),
            meta: {
                title: '问卷调查 - 成长之路 - 佑佐全域职业规划系统',
                login: true,
            }
        },
        {
            path: '/goal',
            name: 'goal',
            component: __import__('goal/goal_home'),
            meta: {
                title: '目标规划 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/plan',
            name: 'plan',
            component: __import__('plan/plan_home'),
            meta: {
                title: '行动计划 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/test_socket/:id',
            name: 'test_socket',
            component: __import__('symposium/symposium_home'),
            meta: {
                login: true,
                title: '在线研讨 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '/channel/:id',
            name: 'channel',
            component: __import__('channel/channel_home'),
            meta: {
                login: true,
                title: '在线研讨 - 成长之路 - 佑佐全域职业规划系统'
            }
        },
        {
            path: '*',
            name: 'notfound',
            component: __import__('404'),
            meta: {
                title: 'Sorry，页面走丢了... - 佑佐全域职业规划系统'
            }
        }
    ]
})

router.addRoutes(dynamicRouters)

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    if (to.meta.login) {
        if (!store.state.loginState.sign_on) {
            next({
                path: '/login',
                query:{
                    redirect:to.fullPath
                }
            })
        } else {
            next()
        }
    }
    next()
})

router.afterEach((to, from) => {
    window.scrollTo(0, 0)
})

export default router

